module.exports = __webpack_public_path__ + "img/pack_mobile.6379fe49.png";